export default __webpack_public_path__ + "static/media/groundunt-icon.0a077408.svg";